import React from "react";
import { Button, ButtonProps } from "@mui/material";

/**
 * Standard red button used across the app for destructive actions (e.g.
 * Initiatives' bulk "Delete"). Relies on the theme's error palette rather than
 * a hardcoded hex, so it stays in sync with every other error-colored control.
 * For the icon-only row delete affordance, use DeleteIconButton instead.
 */
export const DangerButton: React.FC<ButtonProps> = ({ children, ...props }) => (
  <Button variant="contained" color="error" size="small" {...props}>
    {children}
  </Button>
);
